// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-tabs-container{-webkit-overflow-scrolling:touch;overflow-x:auto;scroll-behavior:smooth;flex-wrap:nowrap}.bw-tabs-container::-webkit-scrollbar{display:none}.bw-button-prev,.bw-button-next{position:absolute}.bw-button-prev{left:0;text-align:left}.bw-button-next{right:0;text-align:right}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs-container": "bw-tabs-container",
	"button-prev": "bw-button-prev",
	"button-next": "bw-button-next"
};
module.exports = ___CSS_LOADER_EXPORT___;
